import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as T from "utils/types";
import * as U from 'utils/utils';

export const cntPerPage = 10;


const urlQuery = new URLSearchParams(window.location.search);

const SDG_urlQuery = urlQuery.get('SDG');
const search_urlQuery = urlQuery.get('search');
const fclt_urlQuery = urlQuery.get('faculty');

const fclt_shortToId: T.StringToNumberObject = {
    FASS: 11, //Faculty of Arts and Social Sciences
    SCI: 12, //Faculty of Science
    FAS: 9, //Faculty of Applied Sciences
    BUS: 7, //Beedie School of Business
    FCAT: 13, //Faculty of Communication, Art & Tech
    EDUC: 15, //Faculty of Education
    FENV: 10, //Faculty of Environment
    FHS: 16, //Faculty of Health Sciences
}
const fcltId = fclt_urlQuery?fclt_shortToId[fclt_urlQuery]:null; 
// be careful about above line: fclt_urlQuery could be an illegal key string 

export const initialState: T.SearchPageUserInputs = {
    searchInput: search_urlQuery ? search_urlQuery : "",
    keywordType: "search",
    facultyID: fcltId?fcltId:-1, // -1 means any fclt
    departmentID: -1, // -1 means any dept
    searchTab: T.SearchTab.RESEARCHERS,
    rsrSpecific: {
        acceptingGraduateStudentChecked: false,
        C3IChecked: false,
        SDGs: SDG_urlQuery ? SDG_urlQuery.split(' ').map(x=>Number(x)).filter(
            x => !isNaN(x) && x>=1 && x<= 17
        ):[]
    },
    pubSpecific: {
        year: -1, // -1 means any year
        sortType: "-date"
    },
    gsPubSpecific: {
        year: -1, // -1 means any year
        sortType: "-year"
    },
    altTrendingSpecific: { // dedicated for altmetric trending
        sortType: "-historical_mentions_1w"
    },
    creationSpecific: {
        year: -1, // -1 means any year
        sortType: '-premiere_year'
    },
}

// search page user inputs
export default createSlice({
    name: 'searchPgUserInputsS',
    initialState,
    reducers: {
        reset: ()=>initialState,
        setSearchInput: (state, action: PayloadAction<string>) => {
            state.searchInput = action.payload;
        },
        setKeywordType: (state, action: PayloadAction<T.keywordType>) => {
            state.keywordType = action.payload;
        },
        setFacultyID: (state, action: PayloadAction<number>) => {
            state.facultyID = action.payload;
            state.departmentID = -1;
        },
        setDepartmentID: (state, action: PayloadAction<{deptID:number, fcltID:number}>) => {
            state.departmentID = action.payload.deptID;
            state.facultyID = action.payload.fcltID; 
            // the above one line is for: 
            // when fclt Select is All Fclts, and dept Select is All Depts, user can use dept to change the fclt!
        },
        setSearchTab: (state, action: PayloadAction<T.SearchTab>) => {
            state.searchTab = action.payload;
        },
        setAcceptingGraduateStudentChecked: (state, action: PayloadAction<boolean>) => {
            state.rsrSpecific.acceptingGraduateStudentChecked = action.payload;
        },
        setC3IChecked: (state, action: PayloadAction<boolean>) => {
            state.rsrSpecific.C3IChecked = action.payload;
        },
        setSDG: (state, action: PayloadAction<number>) => {
            if (action.payload === 0) {
                state.rsrSpecific.SDGs = initialState.rsrSpecific.SDGs;
            } else {
                let SDGs = state.rsrSpecific.SDGs; 
                if (SDGs.includes(action.payload)) {
                    // Unselect SDG
                    SDGs = SDGs.filter( x => x !== action.payload).sort(U.compareNumbers);
                } else {
                    // Select SDG
                    SDGs = SDGs.concat(action.payload).sort(U.compareNumbers);
                }
                state.rsrSpecific.SDGs = SDGs;
            }
        },
        setYear: (state, action: PayloadAction<number>)=>{
            state.pubSpecific.year = action.payload;
        },
        setGsPubYear: (state, action: PayloadAction<number>)=>{
            state.gsPubSpecific.year = action.payload;
        },
        setCreationYear: (state, action: PayloadAction<number>)=>{
            state.creationSpecific.year = action.payload;
        },
        setSortType: (state, action: PayloadAction<T.pubListSortType>)=>{
            state.pubSpecific.sortType = action.payload;
        },
        setGsPubSortType: (state, action: PayloadAction<T.gsPubListSortType>)=>{
            state.gsPubSpecific.sortType = action.payload;
        },
        setAltTrendingSortType: (state, action: PayloadAction<T.altTrendingSortType>)=>{
            state.altTrendingSpecific.sortType = action.payload;
        },
    }
});